import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {gsap} from "gsap";
import {FreespinSymbol} from "../../reelsfs/FreespinSymbol";
import {DevilsCrossRoadFreespinReel} from "../../reelsfs/DevilsCrossRoadFreespinReel";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadGameConfig} from "../../DevilsCrossRoadGameConfig";


export class FreespinSetSticky implements SimplePresentation {
    name: string = "FreespinSetSticky";

    shouldRun(): boolean {
        return (DevilsCrossRoad.model.gameData.mode == GameMode.FREESPIN || DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();

        const checkAgainstSymNames: string [] = DevilsCrossRoadGameConfig.POSSIBLE_STICKY_SYMBOLS;
        const reelsToStick: DevilsCrossRoadFreespinReel [] = [];
        const symsToStick: FreespinSymbol [] = [];
        const visibleSymbols = DevilsCrossRoad.freespinReelAreaView.getAllVisibleSymbols();
        const reels: DevilsCrossRoadFreespinReel [][] = DevilsCrossRoad.freespinReelAreaView.reels;

        visibleSymbols.forEach((symData) => {
            if(symData && checkAgainstSymNames.indexOf(symData.name) > -1) {
                reelsToStick.push(reels[symData.reelId][symData.reelPosition]);
                const symbol = (<FreespinSymbol>symData.positionable);
                tl.add(() => {
                    if(symbol && DevilsCrossRoad.LANDED_STICKYS_IDS.indexOf(symData.reelId) < 0) {
                        DevilsCrossRoad.LANDED_STICKYS_IDS.push(symData.reelId);
                    }
                });
                symsToStick.push((<FreespinSymbol>symData.positionable));

            }
        });

        let indicatorReset:boolean = false;

        reelsToStick.forEach((reel) => {
            if(reel && reel.model) {
                reel.model.setAsStickyReel();

                if(!indicatorReset) {
                    indicatorReset = true;
                }
            }
        });

        //console.log("ALL VISIBLE SYMBOLS", visibleSymbols);

        tl.add(() => controller.finish(), "+=0.2");
    }

}